import { Navigate } from "react-router-dom";
import Login from "./components/login/Login";
import Dashboard from "./pages/dashboard/teamDashboard/Dashboard";
import { UnoStoreHooks } from "@simulanisindia/ui";
import Project from "./pages/project/Project";
import BlankPages from "./pages/BlankPages";
import ProjectDetails from "./pages/project/Details";
import Private from "./components/layout/Private";
import Editor from "./pages/editor/Editor";
import Preview from "./pages/project/Preview";
import Public from "./components/layout/Public";
import PublishProject from "./pages/publish/publish";
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import View from "../src/pages/viewer/View";

const { useUnoSelector } = UnoStoreHooks;

const RedirectToDashboard = () => {
  const userData = useUnoSelector((state) => state.user);
  const configData = useUnoSelector((state) => state.config);
  let filterPrivateRoutes = privateRoutes.filter(route => route.viewer === undefined || route.viewer === (configData?.config?.permissions?.showSideBar ?? true));

  const uuid = userData?.user?.group?.uuid;

  if (!uuid) return null;

  let redirectUri = (filterPrivateRoutes[0].path).replace(":uuid", uuid);
  return <Navigate to={redirectUri} />;
};

const DirectToUno = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const configData = useUnoSelector((state) => state.config);
  const _tokenParam = urlParams.get("referrer");
  let token = "";
  let initialPath = null;
  if (_tokenParam) {
    const decoded = jwtDecode(_tokenParam);
    localStorage.setItem("token", decoded?.token);
    token = decoded?.token;
    initialPath = decoded?.redirectUri;
  } else if (localStorage.getItem("token")) {
    token = localStorage.getItem("token");
  }
  localStorage.clear();
  sessionStorage.clear();
  const payload = {
    origin: window.location.origin,
    redirectUri: window.location.pathname,
  };
  token = jwtEncode(payload, "");
  window.location.href = `${configData?.config?.redirectUri}?referrer=${token}`;
};

export const privateRoutes = [
  {
    path: "/dashboard/:uuid",
    element: Dashboard,
    layout: Private,
    showSidebar: true,
    showHeader: true,
    enableMobileView: true,
    viewer: true,
  },
  {
    path: "/project/:uuid",
    element: Project,
    layout: Private,
    showSidebar: true,
    showHeader: true,
    enableMobileView: true,
  },
  {
    path: "/project/details/:uuid",
    element: ProjectDetails,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: true,
  },
  {
    path: "/editor",
    element: Editor,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: true,
  },
  {
    path: "/editor/:uuid",
    element: Editor,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: true,
  },
  {
    path: "/view/:uuid",
    element: View,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
  {
    path: "/:uuid/:versionId",
    element: PublishProject,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: true,
  },
  {
    path: "/:uuid",
    element: Preview,
    layout: Public,
    showSidebar: false,
    showHeader: false,
    enableMobileView: true,
  },
  {
    path: "*",
    element: RedirectToDashboard,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
];

export const publicRoutes = [
  {
    path: "/gateway",
    element: Login,
    layout: Public,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
  {
    path: "/:uuid",
    element: Preview,
    layout: Public,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
  {
    path: "/view/:uuid",
    element: View,
    layout: Private,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
  {
    path: "*",
    element: DirectToUno,
    layout: Public,
    showSidebar: false,
    showHeader: false,
    enableMobileView: false,
  },
];
